import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NewRegularInvitationFormGroup } from './new-invitation-form.helper';

@Component({
  selector: 'app-new-invitation-form',
  templateUrl: './new-invitation-form.component.html',
  styleUrls: ['./new-invitation-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewInvitationFormComponent implements OnInit {
  formGroup: FormGroup<NewRegularInvitationFormGroup>;
  gatewaySerial: string;
  comment: string;

  @Input() error: {
    errorType?: string;
    message?: string;
    statusCode?: number;
  } = {};

  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();

  @Output() newInvitation: EventEmitter<{
    gatewaySerial: string;
    comment?: string;
  }> = new EventEmitter<{
    gatewaySerial: string;
    comment?: string;
  }>();

  constructor() {}

  ngOnInit(): void {
    this.formGroup = new FormGroup<NewRegularInvitationFormGroup>({
      comment: new FormControl<string>(this.comment),
      gatewaySerial: new FormControl<string>(this.gatewaySerial, [
        Validators.pattern(/^([0-9]{7})|^([0-9]{7}).*$/im),
        Validators.minLength(7),
      ]),
    });
  }

  onCreate(): void {
    const comment = this.formGroup?.value?.comment
      ? this.formGroup.value.comment.trim()
      : undefined;
    const gatewaySerial = this.formGroup?.value?.gatewaySerial
      ? this.formGroup.value.gatewaySerial.trim()
      : undefined;
    const payload: {
      gatewaySerial: string;
      comment?: string;
    } = {
      gatewaySerial,
    };

    if (comment) {
      payload.comment = comment;
    }

    this.newInvitation.emit(payload);
  }
}
